import { ContractTenant } from '../../common/validations'

export const getTenantName = (tenant: ContractTenant) =>
  'companyName' in tenant
    ? tenant.companyName
    : 'firstName' in tenant && 'lastName' in tenant
      ? `${tenant.firstName} ${tenant.lastName}`
      : ''
